(function () {
function $c3b10a83b523f372$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$79e617b1955a2616)(arr);
}


function $09c9f293d010c0e1$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$79e617b1955a2616)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$79e617b1955a2616)(o, minLen);
}


function $227c6742e0ff6f82$export$1b5e630bc3aea29f(arr) {
    return (0, $c50969dc1df61e8b$export$7e0947b5ad3404e2)(arr) || (0, $09c9f293d010c0e1$export$1eb58a6e75231000)(arr) || (0, $d4f69c5c6c4654b1$export$a5be06335b3a083c)(arr) || (0, $38c2d4931cb7a7c4$export$e6f3c4780d19eb2b)();
}


"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $cd5a47cf8ef6d766$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $09cbfe85151ea6c6$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $efec029548ccee7f$export$fdf2a89c76341bbf(arr, i) {
    return (0, $09cbfe85151ea6c6$export$e6256bf45c68d561)(arr) || (0, $8ca2848f896a6803$export$2fd15edff6687200)(arr, i) || (0, $d4f69c5c6c4654b1$export$a5be06335b3a083c)(arr, i) || (0, $a0bc1859061deae1$export$60dbc22abd7da546)();
}



"use strict";
/**
 * This class represents the game.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Array.from({
            length: 4
        }, function() {
            return Array(4).fill(0);
        });
        (0, $8713978b2328d32b$export$2996f80ef42b8419)(this, Game);
        this.status = Game.GAME_STATUS.IDLE;
        this.score = 0;
        this.initialState = initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)(row);
        });
        this.state = this.initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)(row);
        });
    }
    (0, $4fc75ccb937ab1df$export$d60067ff2358eee8)(Game, [
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.status = Game.GAME_STATUS.PLAYING;
                this.addNewCell();
                this.addNewCell();
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.state = this.initialState.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)(row);
                });
                this.status = Game.GAME_STATUS.IDLE;
                this.score = 0;
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(rowIndex) {
                    var row = _this.state[rowIndex].filter(function(cell) {
                        return cell !== 0;
                    });
                    if (row.length === 0) return "continue";
                    for(var colIndex = 0; colIndex < row.length - 1; colIndex++){
                        if (row[colIndex] === 0) continue;
                        if (row[colIndex] === row[colIndex + 1]) {
                            row[colIndex] *= 2;
                            row[colIndex + 1] = 0;
                            _this.score += row[colIndex];
                        }
                    }
                    row = row.filter(function(cell) {
                        return cell !== 0;
                    });
                    while(row.length < Game.COL_LENGTH)row.push(0);
                    _this.state[rowIndex] = row;
                };
                if (this.status !== Game.GAME_STATUS.PLAYING) return;
                var previousState = this.state.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)(row);
                });
                for(var rowIndex = 0; rowIndex < Game.ROW_LENGTH; rowIndex++)_loop(rowIndex);
                if (!this.statesAreEqual(previousState, this.state)) this.addNewCell();
                this.checkWinLose();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this, _loop = function(rowIndex) {
                    var row = _this.state[rowIndex].filter(function(cell) {
                        return cell !== 0;
                    });
                    if (row.length === 0) return "continue";
                    for(var colIndex = row.length - 1; colIndex > 0; colIndex--){
                        if (row[colIndex] === 0) continue;
                        if (row[colIndex] === row[colIndex - 1]) {
                            row[colIndex] *= 2;
                            row[colIndex - 1] = 0;
                            _this.score += row[colIndex];
                        }
                    }
                    row = row.filter(function(cell) {
                        return cell !== 0;
                    });
                    while(row.length < Game.COL_LENGTH)row.unshift(0);
                    _this.state[rowIndex] = row;
                };
                if (this.status !== Game.GAME_STATUS.PLAYING) return;
                var previousState = this.state.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)(row);
                });
                for(var rowIndex = 0; rowIndex < Game.ROW_LENGTH; rowIndex++)_loop(rowIndex);
                if (!this.statesAreEqual(previousState, this.state)) this.addNewCell();
                this.checkWinLose();
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this, _loop = function(colIndex) {
                    var column = [];
                    for(var rowIndex = 0; rowIndex < Game.ROW_LENGTH; rowIndex++)if (_this.state[rowIndex][colIndex] !== 0) column.push(_this.state[rowIndex][colIndex]);
                    for(var i = 0; i < column.length - 1; i++){
                        if (column[i] === 0) continue;
                        if (column[i] === column[i + 1]) {
                            column[i] *= 2;
                            column[i + 1] = 0;
                            _this.score += column[i];
                        }
                    }
                    column = column.filter(function(cell) {
                        return cell !== 0;
                    });
                    while(column.length < Game.ROW_LENGTH)column.push(0);
                    for(var rowIndex1 = 0; rowIndex1 < Game.ROW_LENGTH; rowIndex1++)_this.state[rowIndex1][colIndex] = column[rowIndex1];
                };
                if (this.status !== Game.GAME_STATUS.PLAYING) return;
                var previousState = this.state.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)(row);
                });
                for(var colIndex = 0; colIndex < Game.COL_LENGTH; colIndex++)_loop(colIndex);
                if (!this.statesAreEqual(previousState, this.state)) this.addNewCell();
                this.checkWinLose();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this, _loop = function(colIndex) {
                    var column = [];
                    for(var rowIndex = 0; rowIndex < Game.ROW_LENGTH; rowIndex++)if (_this.state[rowIndex][colIndex] !== 0) column.push(_this.state[rowIndex][colIndex]);
                    for(var i = column.length - 1; i > 0; i--){
                        if (column[i] === 0) continue;
                        if (column[i] === column[i - 1]) {
                            column[i] *= 2;
                            column[i - 1] = 0;
                            _this.score += column[i];
                        }
                    }
                    column = column.filter(function(cell) {
                        return cell !== 0;
                    });
                    while(column.length < Game.ROW_LENGTH)column.unshift(0);
                    for(var rowIndex1 = 0; rowIndex1 < Game.ROW_LENGTH; rowIndex1++)_this.state[rowIndex1][colIndex] = column[rowIndex1];
                };
                if (this.status !== Game.GAME_STATUS.PLAYING) return;
                var previousState = this.state.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)(row);
                });
                for(var colIndex = 0; colIndex < Game.COL_LENGTH; colIndex++)_loop(colIndex);
                if (!this.statesAreEqual(previousState, this.state)) this.addNewCell();
                this.checkWinLose();
            }
        },
        {
            key: "statesAreEqual",
            value: function statesAreEqual(state1, state2) {
                return state1.flat().join() === state2.flat().join();
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "addNewCell",
            value: function addNewCell() {
                var emptyCells = [];
                this.state.forEach(function(row, rowIndex) {
                    row.forEach(function(cell, cellIndex) {
                        if (cell === 0) emptyCells.push([
                            rowIndex,
                            cellIndex
                        ]);
                    });
                });
                var _emptyCells_Math_floor = (0, $efec029548ccee7f$export$fdf2a89c76341bbf)(emptyCells[Math.floor(Math.random() * emptyCells.length)], 2), r = _emptyCells_Math_floor[0], c = _emptyCells_Math_floor[1];
                this.state[r][c] = Math.random() < 0.9 ? 2 : 4;
            }
        },
        {
            key: "checkWinLose",
            value: function checkWinLose() {
                if (this.state.flat().includes(2048)) this.status = Game.GAME_STATUS.WIN;
                else if (!this.state.flat().includes(0) && !this.checkMergePossible()) this.status = Game.GAME_STATUS.LOSE;
            }
        },
        {
            key: "checkMergePossible",
            value: function checkMergePossible() {
                for(var rowIndex = 0; rowIndex < Game.ROW_LENGTH; rowIndex++)for(var colIndex = 0; colIndex < Game.COL_LENGTH; colIndex++){
                    if (colIndex < Game.COL_LENGTH - 1 && this.state[rowIndex][colIndex] === this.state[rowIndex][colIndex + 1]) return true;
                    if (rowIndex < Game.ROW_LENGTH - 1 && this.state[rowIndex][colIndex] === this.state[rowIndex + 1][colIndex]) return true;
                }
                return false;
            }
        }
    ]);
    return Game;
}();
(0, $cd5a47cf8ef6d766$export$1e71eb4bef00f6b0)($3d28d7f1aac198f5$var$Game, "GAME_STATUS", {
    IDLE: "idle",
    PLAYING: "playing",
    WIN: "win",
    LOSE: "lose"
});
(0, $cd5a47cf8ef6d766$export$1e71eb4bef00f6b0)($3d28d7f1aac198f5$var$Game, "ROW_LENGTH", 4);
(0, $cd5a47cf8ef6d766$export$1e71eb4bef00f6b0)($3d28d7f1aac198f5$var$Game, "COL_LENGTH", 4);
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$startBtn = document.querySelector(".start");
var $197cd56b15c33885$var$startMsg = document.querySelector(".message-start");
var $197cd56b15c33885$var$scoreEl = document.querySelector(".game-score");
var $197cd56b15c33885$var$winMsg = document.querySelector(".message-win");
var $197cd56b15c33885$var$loseMsg = document.querySelector(".message-lose");
var $197cd56b15c33885$var$cellNodes = document.querySelectorAll(".field-cell");
var $197cd56b15c33885$var$cells = (0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)($197cd56b15c33885$var$cellNodes);
var $197cd56b15c33885$var$updateCells = function() {
    $197cd56b15c33885$var$cells.forEach(function(cell, index) {
        var rowIndex = Math.floor(index / $3d28d7f1aac198f5$exports.COL_LENGTH);
        var colIndex = index % $3d28d7f1aac198f5$exports.COL_LENGTH;
        var cellValue = $197cd56b15c33885$var$game.state[rowIndex][colIndex];
        cell.textContent = cellValue || "";
        cell.className = "field-cell";
        if (cellValue) cell.classList.add("field-cell--".concat(cellValue));
    });
    $197cd56b15c33885$var$scoreEl.textContent = $197cd56b15c33885$var$game.getScore();
};
var $197cd56b15c33885$var$handleArrowPress = function(e) {
    switch(e.key){
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        default:
            break;
    }
    $197cd56b15c33885$var$updateCells();
    if ($197cd56b15c33885$var$game.status === $3d28d7f1aac198f5$exports.GAME_STATUS.WIN) $197cd56b15c33885$var$winMsg.classList.remove("hidden");
    else if ($197cd56b15c33885$var$game.status === $3d28d7f1aac198f5$exports.GAME_STATUS.LOSE) $197cd56b15c33885$var$loseMsg.classList.remove("hidden");
};
var $197cd56b15c33885$var$handleStart = function() {
    if ($197cd56b15c33885$var$game.status === $3d28d7f1aac198f5$exports.GAME_STATUS.IDLE) {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$startBtn.textContent = "Restart";
        $197cd56b15c33885$var$startBtn.classList.add("restart");
        $197cd56b15c33885$var$startBtn.classList.remove("start");
        $197cd56b15c33885$var$startMsg.classList.add("hidden");
    } else {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$startBtn.textContent = "Start";
        $197cd56b15c33885$var$loseMsg.classList.add("hidden");
        $197cd56b15c33885$var$winMsg.classList.add("hidden");
        $197cd56b15c33885$var$startBtn.classList.add("start");
        $197cd56b15c33885$var$startBtn.classList.remove("restart");
        $197cd56b15c33885$var$startMsg.classList.remove("hidden");
    }
    document.addEventListener("keydown", $197cd56b15c33885$var$handleArrowPress);
    $197cd56b15c33885$var$updateCells();
    if ($197cd56b15c33885$var$game.status !== $3d28d7f1aac198f5$exports.GAME_STATUS.PLAYING) document.removeEventListener("keydown", $197cd56b15c33885$var$handleArrowPress);
};
$197cd56b15c33885$var$startBtn.addEventListener("click", $197cd56b15c33885$var$handleStart);

})();
//# sourceMappingURL=index.e8ae8707.js.map
